export const homeObjOne = {
	id: '/',
	lightBg: true,
	lightText: true,
	lightTextDesc: true,
	lightTextTop: false,
	description: 'discover.description',
	headline: 'discover.headline',
	topLine: 'discover.title',
	buttonLabel: 'discover.linked',
	imgStart: 'start',
	img: require('../../images/svg1.svg').default,
	imgBig: false,
	alt: 'Jonatan Ochoa, fullstack javascript developer',
	dark:true,
	primary: false,
	darkText: false,
	start: 'true',
	linked: '/sobre-mi',
	target: ''
}

export const homeObjTwo = { 
	id: '/sobre-mi',
	lightBg: false,
	lightText: false,  
	lightTextDesc: false, 
	lightTextTop: true,
	topLine: 'about.title',
	headline: 'JavaScript | React | Node JS | Redux | Express',
	description: 'about.description',
	buttonLabel: 'about.linked',
	imgStart: '', 
	img: require('../../images/jochoa-removebg-preview.png'),
	imgBig: true,
	alt: 'Jonatan Ochoa, Full Stack Developer',
	dark: false,
	primary: false,
	darkText: false,
	start: 'true',
	linked: 'https://drive.google.com/file/d/1mIP0cA0fSiRYT4cEFPUsol5EQnhZ_LS6/view?usp=sharing',
	target: '_blank',
}
export const homeObjThree = {
	id: '/tecnologias',
	lightBg: false,
	lightText: false,
	lightTextDesc: false,
	lightTextTop: true,
	topLine: 'skills.title',
	headline: 'skills.tools',
	description: 'Javascript, Typescript , React, Redux, Node JS, Express, Git, Github, PostgresSQL, MongoDB, Sequelize, Mongoose, Tailwind, Jira, Slack, Trello, Firebase, Vercel',
	buttonLabel: 'skills.linked',
	imgStart: 'start',
	img: require('../../images/svg2.svg').default,
	imgBig: false,
	alt: 'Jonatan Ochoa, Developer javascript',
	dark: true,
	primary: true,
	darkText: false,
	start: 'false',
	linked: '/proyectos',
	target: ''
}
